import { ActionTree } from 'vuex'
import { VasState } from './types'
import { RootState } from '../../types'
import * as types from './mutations-types'
import { placeFromAddressObject } from '@/common/utils'
import TinabaAPI from '@/common/TinabaAPI'

const API = new TinabaAPI()

export const actions: ActionTree<VasState, RootState> = {
  async fetchMerchantDetails ({ commit }, { merchantId, shopId }) {
    try {
      const data = await API.$vas.getPublicDetails(merchantId)
      commit(types.setMerchantDetails, data)

      const shopData = await API.$vas.getShopPublicDetails(merchantId, shopId)
      commit(types.setMerchantShopDetails, shopData)
    } catch (error) {

    }
  },
  async fetchMerchant ({ commit, dispatch }, { merchantId, shopId, vasId }) {
    commit('global/toggleGlobalLoading', true, { root: true })
    try {
      dispatch('fetchMerchantDetails', { merchantId, shopId })
      const { _embedded = { vasses: [] } } = await API.$vas.listPublicVasses(merchantId)
      commit(types.setCurrentVAS, { shopId, vasId, merchantId })
      commit(types.setShops, _embedded.vasses)
      await dispatch('global/fetchCart', null, { root: true })
    } catch (error) {}
    finally {
      commit('global/toggleGlobalLoading', false, { root: true })
    }
  },
  async fetchMenu ({ commit, getters }) {
    if (!getters.merchant) return null
    commit('global/toggleGlobalLoading', true, { root: true })
    const { businessId, shopId, configuration  } = getters.merchant
    try {
      const menu = await API.$vas.getMenu (businessId, shopId, configuration.menuId)
      commit(types.setShopMenu, menu)
    } catch (error) {}
    finally {
      commit('global/toggleGlobalLoading', false, { root: true })
    }
  },
  restoreFromCart ({ commit, getters }, cart: MerchantCart) {
    let payload: any = {}
    if (cart && cart.customer && cart.customer.email) {
      payload.email = cart.customer.email
    }

    if (cart && cart.customer && cart.customer.fiscalCode) {
      payload.fiscalCode = cart.customer.fiscalCode
    }

    if (cart && cart.customer && cart.customer.pickupPoint) {
      payload.pickupPoint = cart.customer.pickupPoint
    }

    if (cart && cart.customer && cart.customer.message) {
      payload.message = cart.customer.message
    }

    if (cart.billingAddress && !(cart.billingAddress.defaultBillingAddress && cart.shippingAddress)) {
      if (cart.billingAddress.givenName) payload['firstname'] = cart.billingAddress.givenName
      if (cart.billingAddress.familyName) payload['lastname'] = cart.billingAddress.familyName
      if (cart.billingAddress.telephone) payload['telephone'] = cart.billingAddress.telephone
      commit(types.setCustomerDetails, payload)
    }

    if (getters.hasDelivery && cart.shippingAddress) {
      let address = cart.shippingAddress
      if (cart.billingAddress && cart.billingAddress.defaultBillingAddress) {
        address = cart.billingAddress
      }
      if (address.givenName) payload['firstname'] = address.givenName
      if (address.familyName) payload['lastname'] = address.familyName
      if (address.telephone) payload['telephone'] = address.telephone
      if (address.streetAddress)
      {
        const splitStreetAddress = address.streetAddress.split(', ');
        if(splitStreetAddress.length > 0) address.route = splitStreetAddress[0];
      }
      if (address.description) payload['notes'] = address.description;


      commit(types.setCustomerDetails, payload)
      commit(types.setShippingAddress, placeFromAddressObject(address))
    }
  },
  async validateAddressWithApi ({ getters, commit }, payload) {
    if (!getters.merchant) return null
    commit('global/toggleGlobalLoading', true, { root: true })
    const { businessId, shopId, id  } = getters.merchant
    try {
      const validation = await API.$vas.validateDeliveryAddress (businessId, shopId, id, payload)
      return validation
    } catch (error) {
      console.log(error)
      throw error
    } finally {
      commit('global/toggleGlobalLoading', false, { root: true })
    }
  },
};
